// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__aNsYx","selected":"Chip_selected__107dP"};